import { render, staticRenderFns } from "./LinkedApplymenty.vue?vue&type=template&id=50a9c8b4&scoped=true&"
import script from "./LinkedApplymenty.vue?vue&type=script&lang=js&"
export * from "./LinkedApplymenty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a9c8b4",
  null
  
)

export default component.exports